// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/pop-out-icon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/close.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-player-module__video-player___srDO3 {
  height: 100%;
}
.video-player-module__video-player__video___Hueg1 {
  height: 100%;
}
.video-player-module__video-player__playback-ended___wGgid {
  width: 0;
  height: 0;
  overflow: hidden;
  display: block;
}
.video-player-module__video-player--keyboard-focused___S0bGF .video-js.vjs-has-started:before {
  opacity: 1;
  visibility: visible;
}
.video-player-module__video-player--keyboard-focused___S0bGF .video-js.vjs-has-started .vjs-control-bar {
  opacity: 1;
  visibility: visible;
}

.video-js .vjs-control.video-player-module__custom-button___S2i1B {
  display: none;
  z-index: 1;
  opacity: 0;
  pointer-events: none;
  width: 24px;
  height: 24px;
  transition: opacity 300ms ease-out;
}
.video-js .vjs-control.video-player-module__custom-button--top-right___LEFU0, .video-js .vjs-control.video-player-module__custom-button--top-left___lTQHq {
  position: absolute;
  top: 16px;
}
.video-js .vjs-control.video-player-module__custom-button--top-right___LEFU0 {
  right: 16px;
}
.video-js .vjs-control.video-player-module__custom-button--top-left___lTQHq {
  left: 16px;
}
.video-js .vjs-control.video-player-module__custom-button--pop-out___pwoyM {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.video-js .vjs-control.video-player-module__custom-button--close-fullscreen___FWJIq {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.video-js.vjs-has-started.vjs-user-active .vjs-control.video-player-module__custom-button___S2i1B {
  display: inline-block;
  opacity: 1;
  visibility: visible;
  pointer-events: all;
}
.video-js.vjs-has-started.vjs-user-active .vjs-control.video-player-module__custom-button--fullscreen-only___Vn7zz {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

.video-js.vjs-has-started.vjs-user-active.vjs-fullscreen .vjs-control.video-player-module__custom-button--fullscreen-only___Vn7zz {
  display: inline-block;
  opacity: 1;
  visibility: visible;
  pointer-events: all;
}
.video-js.vjs-has-started.vjs-user-active.vjs-fullscreen .vjs-control.video-player-module__custom-button--inline-only___rqhKV {
  display: none;
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/components/content/pop-out-video/components/video-player/video-player.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AACE;EACE,YAAA;AACJ;AAEE;EACE,QAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;AAAJ;AAMQ;EACE,UAAA;EACA,mBAAA;AAJV;AAMQ;EACE,UAAA;EACA,mBAAA;AAJV;;AAYE;EACE,aAAA;EACA,UAAA;EACA,UAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;AATJ;AAWI;EAEE,kBAAA;EACA,SAAA;AAVN;AAaI;EACE,WAAA;AAXN;AAcI;EACE,UAAA;AAZN;AAeI;EACE,yDAAA;AAbN;AAgBI;EACE,yDAAA;AAdN;;AAoBE;EACE,qBAAA;EACA,UAAA;EACA,mBAAA;EACA,mBAAA;AAjBJ;AAmBI;EACE,UAAA;EACA,kBAAA;EACA,oBAAA;AAjBN;;AAwBI;EACE,qBAAA;EACA,UAAA;EACA,mBAAA;EACA,mBAAA;AArBN;AAwBI;EACE,aAAA;AAtBN","sourcesContent":[".video-player {\n  height: 100%;\n\n  &__video {\n    height: 100%;\n  }\n\n  &__playback-ended {\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    display: block;\n  }\n\n  &--keyboard-focused {\n    :global .video-js {\n      &.vjs-has-started {\n        &:before {\n          opacity: 1;\n          visibility: visible;\n        }\n        .vjs-control-bar {\n          opacity: 1;\n          visibility: visible;\n        }\n      }\n    }\n  }\n}\n\n:global(.video-js .vjs-control) {\n  &.custom-button {\n    display: none;\n    z-index: 1;\n    opacity: 0;\n    pointer-events: none;\n    width: 24px;\n    height: 24px;\n    transition: opacity 300ms ease-out;\n\n    &--top-right,\n    &--top-left {\n      position: absolute;\n      top: 16px;\n    }\n\n    &--top-right {\n      right: 16px;\n    }\n\n    &--top-left {\n      left: 16px;\n    }\n\n    &--pop-out {\n      background-image: url('../../assets/pop-out-icon.svg');\n    }\n\n    &--close-fullscreen {\n      background-image: url('../../assets/close.svg');\n    }\n  }\n}\n\n:global(.video-js.vjs-has-started.vjs-user-active .vjs-control) {\n  &.custom-button {\n    display: inline-block;\n    opacity: 1;\n    visibility: visible;\n    pointer-events: all;\n\n    &--fullscreen-only {\n      opacity: 0;\n      visibility: hidden;\n      pointer-events: none;\n    }\n  }\n}\n\n:global(.video-js.vjs-has-started.vjs-user-active.vjs-fullscreen .vjs-control) {\n  &.custom-button {\n    &--fullscreen-only {\n      display: inline-block;\n      opacity: 1;\n      visibility: visible;\n      pointer-events: all;\n    }\n\n    &--inline-only {\n      display: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"video-player": `video-player-module__video-player___srDO3`,
	"video-player__video": `video-player-module__video-player__video___Hueg1`,
	"video-player__playback-ended": `video-player-module__video-player__playback-ended___wGgid`,
	"video-player--keyboard-focused": `video-player-module__video-player--keyboard-focused___S0bGF`,
	"custom-button": `video-player-module__custom-button___S2i1B`,
	"custom-button--top-right": `video-player-module__custom-button--top-right___LEFU0`,
	"custom-button--top-left": `video-player-module__custom-button--top-left___lTQHq`,
	"custom-button--pop-out": `video-player-module__custom-button--pop-out___pwoyM`,
	"custom-button--close-fullscreen": `video-player-module__custom-button--close-fullscreen___FWJIq`,
	"custom-button--fullscreen-only": `video-player-module__custom-button--fullscreen-only___Vn7zz`,
	"custom-button--inline-only": `video-player-module__custom-button--inline-only___rqhKV`
};
export default ___CSS_LOADER_EXPORT___;
